import { ArrowBackOutlined } from '@mui/icons-material';
import { IconButton, Typography } from '@mui/material';
import { DefinitionList, InformationPage, PageSections, SectionCard } from '../../../design-system';

export function MessagingIntegrationDetail({ onBack }: { onBack: () => void }) {
  return <InformationPage
    title="알림·메신저 앱"
    help="Slack 앱이 설치된 워크스페이스에서 사용할 수 있습니다. 앱 설치와 알림 채널 설정은 운영 담당자가 관리합니다."
    width="standard"
    navigation={<IconButton aria-label="연동 목록으로 돌아가기" onClick={onBack}><ArrowBackOutlined /></IconButton>}
  >
    <PageSections>
      <SectionCard title="업무 알림" bodyPadding="standard">
        <Typography variant="body2">입사·퇴사 처리 완료 시 설정된 Slack 채널에 온보딩·오프보딩 완료 알림을 보냅니다.</Typography>
      </SectionCard>
      <SectionCard title="Slack에서 조회" bodyPadding="standard">
        <DefinitionList items={[
          ['내 정보', <Typography component="code" variant="body2">/heyday me</Typography>],
          ['구성원 정보', <Typography component="code" variant="body2">/heyday @사용자</Typography>],
          ['조직 검색', <Typography component="code" variant="body2">/heyday org 조직명</Typography>],
          ['내 휴가', <Typography component="code" variant="body2">/heyday time-off</Typography>],
          ['오늘 부재자', <Typography component="code" variant="body2">/heyday out today</Typography>],
          ['특정 날짜 부재자', <Typography component="code" variant="body2">/heyday out YYYY-MM-DD</Typography>],
        ]} />
      </SectionCard>
    </PageSections>
  </InformationPage>;
}
